import { Flex } from 'antd';
import type { FC } from 'react';
import { SponsorLogos } from '../SponsorLogos.js';
import { Table } from './Table.js';

export const LeaderboardTableAndSponsorLogos: FC = () => {
  return (
    <Flex vertical style={{ minHeight: '300px' }}>
      <Table />
      <SponsorLogos />
    </Flex>
  );
};
